import { MdOutlineFormatIndentDecrease } from "react-icons/md";
import { TbHeartFilled } from "react-icons/tb";
import { IoMdSettings } from "react-icons/io";

export const items = [
  {
    icon: <MdOutlineFormatIndentDecrease />,
    name: "Learn courses online",
    desc: "Aliquam erat volutpat. Donec laoreet iaculis elementum. Aliquam ligula nisi, molestie faucibus tortor.",
  },
  {
    icon: <TbHeartFilled />,
    name: "Best industry experts",
    desc: "Nunc nec nisi vitae ipsum pharetra tincidunt. Nam vel purus dolor. In iaculis arcu et aliquam dapibus.",
  },
  {
    icon: <IoMdSettings />,
    name: "See our best skills",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam feugiat mauris quis volutpat ",
  },
];
